import { PrestationQuestionType } from '@cpce/database/enums';
import z from 'zod';
export const prestationQuestionDataSchema = z
    .object({
    label: z.string().trim().min(1, "L'intitulé de la question est requis"),
    type: z.enum(PrestationQuestionType),
    required: z.boolean(),
    /** Read on a `choice` question only. */
    options: z.array(z.string().trim().min(1, 'Un choix ne peut pas être vide')).default([]),
})
    .refine((data) => data.type !== PrestationQuestionType.choice || data.options.length > 0, {
    message: 'Une liste de choix doit proposer au moins un choix',
    path: ['options'],
})
    .refine((data) => new Set(data.options).size === data.options.length, {
    message: 'Chaque choix ne peut figurer qu’une fois',
    path: ['options'],
});
export const reorderPrestationQuestionsSchema = z.object({
    questionIds: z.array(z.number().int().positive()).min(1),
});
/**
 * As typed: a text or a choice as a string, a date as YYYY-MM-DD, a number or an amount as a
 * number, a oui/non as a boolean. Null or a blank string: not answered.
 */
export const questionAnswerValueSchema = z.union([z.string(), z.number(), z.boolean()]).nullable();
export const questionAnswerSchema = z.object({
    questionId: z.number().int().positive(),
    value: questionAnswerValueSchema,
});
export const dossierAnswersSchema = z.object({
    /** The paying salarié's card, which identifies the dossier the answers go to. */
    externalEmployeeId: z.number().int(),
    answers: z.array(questionAnswerSchema),
});
/** Every question still asked: one left out is cleared. */
export const updateParticipationAnswersSchema = z.object({
    answers: z.array(questionAnswerSchema),
});
export const isBlankAnswer = (value) => value === null || value === undefined || (typeof value === 'string' && value.trim() === '');
